module.exports = {
  container: 'activity/list/container',
  createButton: 'activity/list/createButton',
  item: name => `activity/list/item/${name}`
}
